import { WirelessSwitch } from './WirelessSwitch.model';

export class NLAV extends WirelessSwitch {
    get shouldShowDevice() {
        return !this.deviceIdIncludesHash;
    }
}
